<template>
    <div>
        <v-btn
            small
            flat
            to="/"
        >
            <span class="mr-0">{{homeNavTitle}}</span>
        </v-btn>
        <v-btn
            small
            flat
            to="/news"
        >
            <span class="mr-0">{{newsNavTitle}}</span>
        </v-btn>
        <v-btn
            small
            flat
            to="/trraining"
        >
            <span class="mr-0">{{trainingNavTitle}}</span>
        </v-btn>
        <v-btn
            small
            flat
            to="/aducation"
        >
            <span class="mr-0">{{aducationNavTitle}}</span>
        </v-btn>
        <v-btn
            small
            flat
            to="/programm"
        >
            <span class="mr-0">{{programNavTitle}}</span>
        </v-btn>
        <v-btn
            small
            flat
            to="/about"
        >
            <span class="mr-0">{{aboutNavTitle}}</span>
        </v-btn>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import TwoColumnText from '../TwoColumnText'
import HomeTwoColumnText from '../HomeTwoColumnText'
import NewsColumn from '../NewsColumn'

  export default {
    data () {
      return {
        tab: null
      }
    },
    components: {
        TwoColumnText,
        HomeTwoColumnText,
        NewsColumn,
    },
    computed: {
        ...mapState('ContactModule', [ 
                                        'homeNavTitle',
                                        'newsNavTitle',
                                        'aboutNavTitle',
                                        'trainingNavTitle',
                                        'aducationNavTitle',
                                        'programNavTitle',

                                        'aboutText',
                                        'trainingText', 
                                        'aducationText', 
                                        'programText',

                                        'mainInfoTitle',
                                        'mainInfo1',
                                        'mainInfo2',
                                        'mainInfo3',
                                        'mainInfo4',
                                        'newsText'
                                        ]),
    },
  }
</script>

